module.exports = __webpack_public_path__ + "static/media/grip-vertical.14af612d.svg";